import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { ConfigProvider } from "antd";
import "./assets";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./i18n";
import esES from "antd/lib/locale/es_ES";

ReactDOM.render(
  <ConfigProvider locale={esES}>
    <Router>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </Router>
  </ConfigProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
